/* eslint-disable */

import React, {useState, useEffect} from 'react';
import {FIREBASE_URL} from "../constants/common";
import getRandomArbitrary from "../utils/getRandomArbitrary";


const ViewCounter = ({id, isCard = false}) => {
    const [views, setViews] = useState('');

    // random number for the inital views between 800 and 1000 views
    const initView = getRandomArbitrary(800, 1000);

    // Asynchronously log a view
    useEffect(() => {
        fetch(`${FIREBASE_URL}/views/${id}.json`)
            .then(r => r.text())
            .then(r => parseInt(r))
            .then(views => {
                const newViews = isCard ? (views || initView) : (views || initView ) + 1;

                setViews(newViews.toString())

                if (!isCard) {
                    fetch(`${FIREBASE_URL}/views/${id}.json`, {method: "PUT", body: newViews.toString()}).then()
                }
            })

    }, [id]);

    return `${views || '...' } `;
};

export default ViewCounter;
